import {
  makePaginationState,
  makeDataState,
  STATUSES,
  concatUnique,
} from 'app/utils/redux';

import * as t from './types';

const initialState = {
  restrictionHistories: makePaginationState(),
  restriction: makeDataState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch users
    case `${t.FETCH_MY_RESTRICTIONS}_PENDING`:
      return {
        ...state,
        restrictionHistories: {
          ...state.restrictionHistories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_MY_RESTRICTIONS}_SUCCESS`:
      return {
        ...state,
        restrictionHistories: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: concatUnique(
              state.restrictionHistories.pagination.items,
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_MY_RESTRICTIONS}_ERROR`:
      return {
        ...state,
        restrictionHistories: {
          ...state.restrictionHistories,
          status: STATUSES.ERROR,
          isLoaded: false,
        },
      };

    case `${t.FETCH_USER_RESTRICTION}_PENDING`:
      return {
        ...state,
        restriction: {
          ...state.restriction,
          status: STATUSES.PENDING,
        },
      };

    case `${t.FETCH_USER_RESTRICTION}_SUCCESS`:
      return {
        ...state,
        restriction: {
          ...state.restriction,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
      };

    case `${t.FETCH_USER_RESTRICTION}_ERROR`:
      return {
        ...state,
        restriction: {
          ...state.restriction,
          status: STATUSES.ERROR,
        },
      };

    // reset
    case t.RESET:
      return {
        ...state,
        restrictionHistories: makePaginationState(),
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/restrictionDetail/reducer.js